import { X } from "lucide-react";

export function Modal({ open, onClose, children, testId = "modal" }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid={testId}>
      <div className="absolute inset-0 bg-slate-950/85 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 w-full max-w-4xl">
        <button
          onClick={onClose}
          data-testid="modal-close-button"
          aria-label="Close"
          className="absolute -top-12 right-0 text-white/70 hover:text-white transition-colors"
        >
          <X className="h-7 w-7" />
        </button>
        {children}
      </div>
    </div>
  );
}
